import { encodeGeohash, toRFC3339UTC } from './geohashUtil';

/**
 * Topic communities (community_boards_beta).
 * `thread_ids` is a seed-only helper used by the mock store to wire threads to a
 * board (sets thread.board_id and board.thread_count); it is not part of BoardJSON.
 */
function board(id, name, planetId, createdBy, lat, lon, threadIds = []) {
  return {
    id,
    board_key: name.toLowerCase(),
    name,
    planet_id: planetId,
    created_by_user_id: createdBy,
    latitude: lat,
    longitude: lon,
    geohash: lat != null && lon != null ? encodeGeohash(lat, lon) : null,
    hidden: 0,
    created_at: toRFC3339UTC(new Date()),
    thread_ids: threadIds,
  };
}

/** Geo boards — city + everyday life theme */
const GEO = [
  board(1, 'seoul-morning-coffee', 1, 1001, 37.4979, 127.0276, [1, 7]),
  board(2, 'nyc-subway-rants', 2, 1004, 40.758, -73.9855, [5, 6]),
  board(4, 'jeju-weekend-hikes', 1, 1008, 33.4996, 126.5312, [12]),
  board(5, 'london-pub-evenings', 3, 1010, 51.5074, -0.1278, [13]),
  board(6, 'paris-lunch-bistro', 3, 1011, 48.8566, 2.3522, [14]),
  board(7, 'berlin-startup-cafe', 3, 1012, 52.52, 13.405, [15]),
  board(8, 'rome-sunday-walks', 3, 1013, 41.9028, 12.4964, [16]),
  board(9, 'dubai-marina-jogs', 4, 1014, 25.2048, 55.2708, [17]),
  board(10, 'singapore-hawker-lunch', 4, 1015, 1.3521, 103.8198, [18]),
  board(11, 'sydney-harbour-picnic', 5, 1016, -33.8688, 151.2093, [19]),
  board(12, 'saopaulo-street-art', 6, 1017, -23.5505, -46.6333, [20]),
  board(13, 'mexico-taco-nights', 2, 1018, 19.4326, -99.1332, [21]),
  board(14, 'toronto-lake-bike', 2, 1019, 43.6532, -79.3832, [22]),
  board(15, 'la-beach-volleyball', 2, 1020, 34.0522, -118.2437, [23]),
  board(16, 'cairo-spice-market', 7, 1021, 30.0444, 31.2357, [24]),
  board(17, 'capetown-sunrise-hike', 7, 1022, -33.9249, 18.4241, [25]),
  board(18, 'istanbul-ferry-views', 4, 1023, 41.0082, 28.9784, [26]),
  board(19, 'bangkok-night-market', 4, 1024, 13.7563, 100.5018, [27]),
  board(20, 'hongkong-rooftop-views', 9, 1025, 22.3193, 114.1694, [28]),
  board(21, 'barcelona-tapas-crawl', 3, 1026, 41.3851, 2.1734, [29]),
  board(22, 'amsterdam-canal-bikes', 3, 1027, 52.3676, 4.9041, [30]),
  board(23, 'mumbai-chaat-corner', 4, 1028, 19.076, 72.8777, [31]),
  board(24, 'melbourne-flat-white', 5, 1029, -37.8136, 144.9631, [32]),
  board(33, 'tokyo-ramen-runs', 2, 1001, 35.6595, 139.7004, [4]),
  board(34, 'busan-beach-days', 1, 1007, 35.1587, 129.1604, [11]),
  board(35, 'seoul-hongdae-nights', 1, 1003, 37.5563, 126.9236, [3]),
  board(36, 'han-river-sunset', 1, 1002, 37.5285, 126.932, [2]),
];

/** Global boards — no GPS, everyday community themes */
const GLOBAL = [
  board(3, 'app-wishlist', null, 1001, null, null, [8, 10]),
  board(25, 'morning-routine', null, 1002, null, null, [9]),
  board(26, 'commute-stories', null, 1003, null, null, []),
  board(27, 'pet-parents', null, 1004, null, null, []),
  board(28, 'plant-corner', null, 1005, null, null, []),
  board(29, 'weekend-meal-prep', null, 1006, null, null, []),
  board(30, 'rainy-day-cozy', null, 1007, null, null, []),
  board(31, 'gym-buddies', null, 1008, null, null, []),
  board(32, 'thrift-finds', null, 1009, null, null, []),
  board(37, 'late-night-snacks', null, 1010, null, null, []),
  board(38, 'laundry-day', null, 1011, null, null, []),
  board(39, 'study-cafe', null, 1012, null, null, []),
  board(40, 'roommate-life', null, 1013, null, null, []),
  board(41, 'solo-walks', null, 1014, null, null, []),
  board(42, 'coffee-orders', null, 1015, null, null, []),
  board(43, 'photo-dump', null, 1016, null, null, []),
];

export const SEED_BOARDS = [...GEO, ...GLOBAL].sort((a, b) => a.id - b.id);
